import React, { useRef, useState, useEffect } from "react";
import Cart from "@/components/cart/cart";
import { useUI } from "@/contexts/ui.context";
import { useScrollBlock } from "@/utils/scroll-block";
import { AnimatePresence, m } from "framer-motion";
import useOnClickOutside from "@/utils/use-click-outside";
export default function CartDrawer() {
  const { closeCart, displayCart } = useUI();
  const [blockScroll, allowScroll] = useScrollBlock();
  const ref = useRef(null);
  useOnClickOutside(ref, () => closeCart());
  useEffect(() => {
    if (displayCart) {
      blockScroll();
    } else {
      allowScroll();
    }
  }, [displayCart, blockScroll, allowScroll]);
  return (
    <AnimatePresence>
      {displayCart && (
        <m.div
          initial={{ opacity: 0 }}
          animate={{
            opacity: 100,
          }}
          exit={{ opacity: 0 }}
          className="fixed top-0 w-full h-full bg-black/50 flex items-center justify-end z-[999999]"
          key="overlay"
        >
          <m.div
            initial={{ x: "100%", opacity: 0 }}
            animate={{ x: 0, opacity: 100 }}
            exit={{ x: "100%", opacity: 0 }}
            transition={{ duration: 0.2 }}
            ref={ref}
            className="md:w-[500px] w-full bg-white h-full fixed top-0 z-[999999]"
            key="cart"
          >
            <Cart />
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
